// src/pages/health/WorkoutVideoDetail.jsx
import { useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLoadingGate } from "../../../../../hooks/useLoadingGate";
import BottomNav from "../../../../../components/common/BottomNav";

import { resolveVidPath } from "../../../../../utils/videoSource";
import VideoDetailCard from "../../../../../components/video/VideoDetailCard";
import { TITLES, VIDEOS_BY_ITEM } from "../../../../../data/videos/workoutVideos";

// 공통 유틸
const ensureArray = (v) => (Array.isArray(v) ? v : v ? [v] : []);

export default function WorkoutGuideVideoDetail() {
    const ready = useLoadingGate();
    const navigate = useNavigate();
    const [sp] = useSearchParams();

    // 쿼리에서 전달된 값들
    const v = sp.get("v") || "";           // 예: Static/Static-S-0004
    const itemKey = sp.get("item") || "";  // 예: upper-body, straight-neck ...
    const cat = sp.get("cat") || "";       // 예: tool, body

    // 1) VIDEOS_BY_ITEM에서 id로 해당 영상 찾기
    const base = useMemo(() => {
        if (!v || !itemKey) return null;
        const list = VIDEOS_BY_ITEM[itemKey] ?? [];
        return list.find((video) => video.id === v) ?? null;
    }, [v, itemKey]);

    // 2) 화면에서 쓸 데이터 구성
    const data = useMemo(() => {
        if (!base) {
            return {
                title: TITLES[itemKey] ?? "운동 영상",
                poster: "",
                guide: [],
                videoUrl: "",
            };
        }
        return {
            title: base.title ?? TITLES[itemKey] ?? "운동 영상",
            poster: base.thumb ?? "",
            guide: ensureArray(base.guide),
            videoUrl: base.videoUrl ?? "",
        };
    }, [base, itemKey]);

    // 3) HLS 경로
    const vidPath = useMemo(() => (v ? resolveVidPath(v) : ""), [v]);

    // 4) 필수 파라미터 체크 (없으면 리스트로 되돌리기)
    const paramMissing = !v || !itemKey;

    useEffect(() => {
        if (paramMissing) {
            const qs = new URLSearchParams({
                cat: cat || "tool",
                item: itemKey || "functional",
            }).toString();

            navigate(`/workout/workoutguide/video?${qs}`, { replace: true });
        }
    }, [paramMissing, cat, itemKey, navigate]);

    if (paramMissing) return null;

    return (
        <main className="h-[var(--app-height)] flex flex-col font-suit overflow-y-auto scrollbar-hide px-7 md:px-8 bg-white">
            {!ready ? (
                <div className="flex-1" />
            ) : (
                <VideoDetailCard
                    title={data.title}
                    poster={data.poster}
                    guide={data.guide}
                    vidPath={vidPath}
                    videoUrl={data.videoUrl}
                    onBack={() => navigate(-1)}
                />
            )}

            <BottomNav className="h-16 md:h-[72px]" />
        </main>
    );
}
